module.exports = __webpack_public_path__ + "img/img_share_arrow.ef0a0d94.png";